import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchDispatchOrdersList = (status) => {
  const endpoint = status ? `/vehicles-invoice/vehicleInvoiceOrders?status=${status}` :
    '/vehicles-invoice/vehicleInvoiceOrders';
  return apiActionCreator({
    'endpoint': endpoint,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DISPATCH_ORDERS_LIST,
      ActionTypes.FETCHED_DISPATCH_ORDERS_LIST,
      [ActionTypes.FETCHED_DISPATCH_ORDERS_LIST_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
